/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkMilkIcon16Light = forwardRef('FoodDrinkMilkIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 0a1 1 0 0 0-1 1v2.349L2.336 5.845A2 2 0 0 0 2 6.955V13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.954a2 2 0 0 0-.336-1.11L12 3.35V1a1 1 0 0 0-1-1H5Zm0 1h6v2H5V1Zm1.068 3 1.666 2h4.832l-1.334-2H6.068ZM8 14V7h5v6a1 1 0 0 1-1 1H8ZM7 6.681V14H4a1 1 0 0 1-1-1V6.954a1 1 0 0 1 .168-.555l1.599-2.398L7 6.681Z" })));
});
